import React from "react";
import { createPortal } from "react-dom";
import { Link, useLocation } from "react-router-dom";

function ButtonContent() {
  const { pathname } = useLocation();

  // Hide on admin/auth/donation routes
  const HIDE = [
    /^\/admin($|\/)/,
    /^\/login$/,
    /^\/request-reset-password$/,
    /^\/reset-password\/.+$/,
    /^\/donations\/make-a-change$/,
  ];
  if (HIDE.some((re) => re.test(pathname))) return null;

  return (
    <div
      data-fdb
      className="
        fixed print:hidden z-[2140] pointer-events-none
        right-4 bottom-4 sm:right-6 sm:bottom-6 md:right-8 md:bottom-8
      "
      style={{
        paddingRight: "env(safe-area-inset-right)",
        paddingBottom: "env(safe-area-inset-bottom)",
      }}
    >
      <Link
        to="/donations/make-a-change"
        aria-label="Donate to Shivansh Mahasabha"
        className="
          pointer-events-auto relative inline-flex items-center gap-2
          px-4 sm:px-5 py-3 rounded-full font-extrabold tracking-wide
          bg-gradient-to-r from-[#f9b806] to-[#e0a905]
          text-[#214895] border-2 border-white/40
          shadow-lg shadow-black/10 backdrop-blur-[2px]
          transition-all duration-200 ease-out
          hover:scale-105 active:scale-95 focus:outline-none
          focus-visible:ring-4 focus-visible:ring-[#f9b806]/40
        "
        tabIndex={0}
        role="button"
      >
        <span className="inline-block leading-none" aria-hidden="true">
          <svg className="w-[18px] h-[18px] sm:w-[20px] sm:h-[20px]" viewBox="0 0 24 24" fill="currentColor">
            <path d="M6 4h12v2H6v2h10a3 3 0 0 1-2.824 2H6.91c.86 1.783 2.674 3 4.757 3H14v2h-2.333c-3.16 0-5.88-2.152-6.6-5H4V8h2V6H4V4h2z" />
          </svg>
        </span>
        <span className="text-sm sm:text-base">Donate</span>
      </Link>
    </div>
  );
}

export default function FloatingDonateButton() {
  if (typeof document === "undefined") return null; // SSR/strict safety
  return createPortal(<ButtonContent />, document.body);
}
